import { Case } from "../../models/case";
import { Chat } from "../../models/chat";
import { Document } from "../../models/document";
// import { DocumentEmbedding } from "../../models/document-embedding"; // Deprecated
import { Entry } from "../../models/entry"; // New model for document embeddings
import { Knowledgebase } from "../../models/knowledgebase";
import { User } from "../../models/user";
// import { AILegalCitation } from "../../models/citation"; // DELETED - feature not used
// import { CourtResearchResult } from "../../models/court-research-result"; // DELETED - feature not used
import { AIAgentMetrics } from "@/models/ai-agent-metrics";
import { AILegalMessage } from "@/models/ai-legal-message";
import { Timeline } from "../../models/Timeline";
import { TimelineEvent } from "../../models/TimelineEvent";
import { CaseDocumentsSearch } from "../../models/case-documents-search";
import { _DBReducerMap, createDBServiceSlice } from "./DBServiceReducers";

// Define a proper initial state with empty arrays and objects
const initialState = {
  ids: [],
  entities: {},
  itemsLoaded: false,
  itemsLoading: false,
  itemsLoadedLocaly: false,
  total: 0,
  skip: 0,
  limit: 0
};


// user Reducer
export const {
  slice: UserSlice,
  dbThunks: _UserThunks,
  selectByQuery: _userSelectByQuery,
  selectOneObjectByQuery: _userSelectOneObjectByQuery,
  selectOneFieldByQuery: _userSelectOneFieldByQuery,
  selectors: _userSelectors,
} = createDBServiceSlice<User>({
  service: "users",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBUserReducer,
});
export const DBUserReducer = UserSlice.reducer;
export const UserReducerActions = UserSlice.actions;
export type userReducerActions = keyof typeof UserReducerActions;
export const DBUserThunks = _UserThunks;
export const userSelectors = _userSelectors;
export const userSelectByQuery = _userSelectByQuery;
export const userSelectOneObjectByQuery = _userSelectOneObjectByQuery;
export const userSelectOneFieldByQuery = _userSelectOneFieldByQuery;



// same format for Chat
export const {
  slice: ChatSlice,
  dbThunks: _ChatThunks,
  selectByQuery: _chatSelectByQuery,
  selectOneObjectByQuery: _chatSelectOneObjectByQuery,
  selectOneFieldByQuery: _chatSelectOneFieldByQuery,
  selectors: _chatSelectors,
} = createDBServiceSlice<Chat>({
  service: "chats",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBChatReducer,
});
export const DBChatReducer = ChatSlice.reducer;
export const ChatReducerActions = ChatSlice.actions;
export type chatReducerActions = keyof typeof ChatReducerActions;
export const DBChatThunks = _ChatThunks;
export const chatSelectors = _chatSelectors;
export const chatSelectByQuery = _chatSelectByQuery;
export const chatSelectOneObjectByQuery = _chatSelectOneObjectByQuery;
export const chatSelectOneFieldByQuery = _chatSelectOneFieldByQuery;

// Cases Reducer
export const {
  slice: CaseSlice,
  dbThunks: _CaseThunks,
  selectByQuery: _caseSelectByQuery,
  selectOneObjectByQuery: _caseSelectOneObjectByQuery,
  selectOneFieldByQuery: _caseSelectOneFieldByQuery,
  selectors: _caseSelectors,
  selectByQueryOnlyLength: _caseSelectByQueryOnlyLength,
  selectByQueryOnlyMaxMin: _caseSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<Case>({
  service: "cases",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBCaseReducer,
});
export const DBCaseReducer = CaseSlice.reducer;
export const CaseReducerActions = CaseSlice.actions;
export type caseReducerActions = keyof typeof CaseReducerActions;
export const DBCaseThunks = _CaseThunks;
export const caseSelectors = _caseSelectors;
export const caseSelectByQuery = _caseSelectByQuery;
export const caseSelectByQueryOnlyLength = _caseSelectByQueryOnlyLength;
export const caseSelectByQueryOnlyMaxMin = _caseSelectByQueryOnlyMaxMin;
export const caseSelectOneObjectByQuery = _caseSelectOneObjectByQuery;
export const caseSelectOneFieldByQuery = _caseSelectOneFieldByQuery;

// Knowledgebases Reducer
export const {
  slice: KnowledgebaseSlice,
  dbThunks: _KnowledgebaseThunks,
  selectByQuery: _knowledgebaseSelectByQuery,
  selectOneObjectByQuery: _knowledgebaseSelectOneObjectByQuery,
  selectOneFieldByQuery: _knowledgebaseSelectOneFieldByQuery,
  selectors: _knowledgebaseSelectors,
  selectByQueryOnlyLength: _knowledgebaseSelectByQueryOnlyLength,
  selectByQueryOnlyMaxMin: _knowledgebaseSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<Knowledgebase>({
  service: "knowledgebases",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBKnowledgebaseReducer,
});
export const DBKnowledgebaseReducer = KnowledgebaseSlice.reducer;
export const KnowledgebaseReducerActions = KnowledgebaseSlice.actions;
export type knowledgebaseReducerActions = keyof typeof KnowledgebaseReducerActions;
export const DBKnowledgebaseThunks = _KnowledgebaseThunks;
export const knowledgebaseSelectors = _knowledgebaseSelectors;
export const knowledgebaseSelectByQuery = _knowledgebaseSelectByQuery;
export const knowledgebaseSelectByQueryOnlyLength = _knowledgebaseSelectByQueryOnlyLength;
export const knowledgebaseSelectByQueryOnlyMaxMin = _knowledgebaseSelectByQueryOnlyMaxMin;
export const knowledgebaseSelectOneObjectByQuery = _knowledgebaseSelectOneObjectByQuery;
export const knowledgebaseSelectOneFieldByQuery = _knowledgebaseSelectOneFieldByQuery;

// Documents Reducer
export const {
  slice: DocumentSlice,
  dbThunks: _DocumentThunks,
  selectByQuery: _documentSelectByQuery,
  selectOneObjectByQuery: _documentSelectOneObjectByQuery,
  selectOneFieldByQuery: _documentSelectOneFieldByQuery,
  selectors: _documentSelectors,
  selectByQueryOnlyLength: _documentSelectByQueryOnlyLength,
  selectByQueryOnlyMaxMin: _documentSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<Document>({
  service: "documents",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBDocumentReducer,
});
export const DBDocumentReducer = DocumentSlice.reducer;
export const DocumentReducerActions = DocumentSlice.actions;
export type documentReducerActions = keyof typeof DocumentReducerActions;
export const DBDocumentThunks = _DocumentThunks;
export const documentSelectors = _documentSelectors;
export const documentSelectByQuery = _documentSelectByQuery;
export const documentSelectByQueryOnlyLength = _documentSelectByQueryOnlyLength;
export const documentSelectByQueryOnlyMaxMin = _documentSelectByQueryOnlyMaxMin;
export const documentSelectOneObjectByQuery = _documentSelectOneObjectByQuery;
export const documentSelectOneFieldByQuery = _documentSelectOneFieldByQuery;

// Entries Reducer - New replacement for document-embeddings
export const {
  slice: EntrySlice,
  dbThunks: _EntryThunks,
  selectByQuery: _entrySelectByQuery,
  selectOneObjectByQuery: _entrySelectOneObjectByQuery,
  selectOneFieldByQuery: _entrySelectOneFieldByQuery,
  selectors: _entrySelectors,
  selectByQueryOnlyLength: _entrySelectByQueryOnlyLength,
  selectByQueryOnlyMaxMin: _entrySelectByQueryOnlyMaxMin,
} = createDBServiceSlice<Entry>({
  service: "entries",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBEntryReducer,
});
export const DBEntryReducer = EntrySlice.reducer;
export const EntryReducerActions = EntrySlice.actions;
export type entryReducerActions = keyof typeof EntryReducerActions;
export const DBEntryThunks = _EntryThunks;
export const entrySelectors = _entrySelectors;
export const entrySelectByQuery = _entrySelectByQuery;
export const entrySelectByQueryOnlyLength = _entrySelectByQueryOnlyLength;
export const entrySelectByQueryOnlyMaxMin = _entrySelectByQueryOnlyMaxMin;
export const entrySelectOneObjectByQuery = _entrySelectOneObjectByQuery;
export const entrySelectOneFieldByQuery = _entrySelectOneFieldByQuery;

// Citation Reducer - DELETED (feature not used)
// export const { ... } = createDBServiceSlice<AILegalCitation>({ service: "ai-legal-citations", ... });

// Message Reducer
export const {
  slice: MessageSlice,
  dbThunks: _MessageThunks,
  selectByQuery: _messageSelectByQuery,
  selectOneObjectByQuery: _messageSelectOneObjectByQuery,
  selectOneFieldByQuery: _messageSelectOneFieldByQuery,
  selectors: _messageSelectors,
  selectByQueryOnlyLength: _messageSelectByQueryOnlyLength,
  selectByQueryOnlyMaxMin: _messageSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<AILegalMessage>({
  service: "ai-legal-messages",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBMessageReducer,
});
export const DBMessageReducer = MessageSlice.reducer;
export const MessageReducerActions = MessageSlice.actions;
export type messageReducerActions = keyof typeof MessageReducerActions;
export const DBMessageThunks = _MessageThunks;
export const messageSelectors = _messageSelectors;
export const messageSelectByQuery = _messageSelectByQuery;
export const messageSelectByQueryOnlyLength = _messageSelectByQueryOnlyLength;
export const messageSelectByQueryOnlyMaxMin = _messageSelectByQueryOnlyMaxMin;
export const messageSelectOneObjectByQuery = _messageSelectOneObjectByQuery;
export const messageSelectOneFieldByQuery = _messageSelectOneFieldByQuery;

// AI Agent Metrics Reducer
export const {
  slice: AIAgentMetricsSlice,
  dbThunks: _AIAgentMetricsThunks,
  selectByQuery: _aiAgentMetricsSelectByQuery,
  selectOneObjectByQuery: _aiAgentMetricsSelectOneObjectByQuery,
  selectOneFieldByQuery: _aiAgentMetricsSelectOneFieldByQuery,
  selectors: _aiAgentMetricsSelectors,
  selectByQueryOnlyLength: _aiAgentMetricsSelectByQueryOnlyLength,
  selectByQueryOnlyMaxMin: _aiAgentMetricsSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<AIAgentMetrics>({
  service: "ai-agent-metrics",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBAIAgentMetricsReducer,
});

export const DBAIAgentMetricsReducer = AIAgentMetricsSlice.reducer;
export const AIAgentMetricsReducerActions = AIAgentMetricsSlice.actions;
export type aiAgentMetricsReducerActions = keyof typeof AIAgentMetricsReducerActions;
export const DBAIAgentMetricsThunks = _AIAgentMetricsThunks;
export const aiAgentMetricsSelectors = _aiAgentMetricsSelectors;
export const aiAgentMetricsSelectByQuery = _aiAgentMetricsSelectByQuery;
export const aiAgentMetricsSelectByQueryOnlyLength = _aiAgentMetricsSelectByQueryOnlyLength;
export const aiAgentMetricsSelectByQueryOnlyMaxMin = _aiAgentMetricsSelectByQueryOnlyMaxMin;
export const aiAgentMetricsSelectOneObjectByQuery = _aiAgentMetricsSelectOneObjectByQuery;
export const aiAgentMetricsSelectOneFieldByQuery = _aiAgentMetricsSelectOneFieldByQuery;

// Court Research Results Reducer - DELETED (feature not used)
// export const { ... } = createDBServiceSlice<CourtResearchResult>({ service: "court-research-results", ... });

// Timeline Reducer
export const {
  slice: TimelineSlice,
  dbThunks: _TimelineThunks,
  selectByQuery: _timelineSelectByQuery,
  selectOneObjectByQuery: _timelineSelectOneObjectByQuery,
  selectOneFieldByQuery: _timelineSelectOneFieldByQuery,
  selectors: _timelineSelectors,
  selectByQueryOnlyLength: _timelineSelectByQueryOnlyLength,
  selectByQueryOnlyMaxMin: _timelineSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<Timeline>({
  service: "timelines",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBTimelineReducer,
});

export const DBTimelineReducer = TimelineSlice.reducer;
export const TimelineReducerActions = TimelineSlice.actions;
export type timelineReducerActions = keyof typeof TimelineReducerActions;
export const DBTimelineThunks = _TimelineThunks;
export const timelineSelectors = _timelineSelectors;
export const timelineSelectByQuery = _timelineSelectByQuery;
export const timelineSelectByQueryOnlyLength = _timelineSelectByQueryOnlyLength;
export const timelineSelectByQueryOnlyMaxMin = _timelineSelectByQueryOnlyMaxMin;
export const timelineSelectOneObjectByQuery = _timelineSelectOneObjectByQuery;
export const timelineSelectOneFieldByQuery = _timelineSelectOneFieldByQuery;

// Timeline Event Reducer
export const {
  slice: TimelineEventSlice,
  dbThunks: _TimelineEventThunks,
  selectByQuery: _timelineEventSelectByQuery,
  selectOneObjectByQuery: _timelineEventSelectOneObjectByQuery,
  selectOneFieldByQuery: _timelineEventSelectOneFieldByQuery,
  selectors: _timelineEventSelectors,
  selectByQueryOnlyLength: _timelineEventSelectByQueryOnlyLength,
  selectByQueryOnlyMaxMin: _timelineEventSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<TimelineEvent>({
  service: "timeline-events",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBTimelineEventReducer,
});

export const DBTimelineEventReducer = TimelineEventSlice.reducer;
export const TimelineEventReducerActions = TimelineEventSlice.actions;
export type timelineEventReducerActions = keyof typeof TimelineEventReducerActions;
export const DBTimelineEventThunks = _TimelineEventThunks;
export const timelineEventSelectors = _timelineEventSelectors;
export const timelineEventSelectByQuery = _timelineEventSelectByQuery;
export const timelineEventSelectByQueryOnlyLength = _timelineEventSelectByQueryOnlyLength;
export const timelineEventSelectByQueryOnlyMaxMin = _timelineEventSelectByQueryOnlyMaxMin;
export const timelineEventSelectOneObjectByQuery = _timelineEventSelectOneObjectByQuery;
export const timelineEventSelectOneFieldByQuery = _timelineEventSelectOneFieldByQuery;

// Case Users Reducer
import { CaseUser } from "../../models/case-user";

export const {
  slice: CaseUserSlice,
  dbThunks: _CaseUserThunks,
  selectByQuery: _caseUserSelectByQuery,
  selectOneObjectByQuery: _caseUserSelectOneObjectByQuery,
  selectOneFieldByQuery: _caseUserSelectOneFieldByQuery,
  selectors: _caseUserSelectors,
  selectByQueryOnlyLength: _caseUserSelectByQueryOnlyLength,
  selectByQueryOnlyMaxMin: _caseUserSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<CaseUser>({
  service: "case-users",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBCaseUserReducer,
});

export const DBCaseUserReducer = CaseUserSlice.reducer;
export const CaseUserReducerActions = CaseUserSlice.actions;
export type caseUserReducerActions = keyof typeof CaseUserReducerActions;
export const DBCaseUserThunks = _CaseUserThunks;
export const caseUserSelectors = _caseUserSelectors;
export const caseUserSelectByQuery = _caseUserSelectByQuery;
export const caseUserSelectByQueryOnlyLength = _caseUserSelectByQueryOnlyLength;
export const caseUserSelectByQueryOnlyMaxMin = _caseUserSelectByQueryOnlyMaxMin;
export const caseUserSelectOneObjectByQuery = _caseUserSelectOneObjectByQuery;
export const caseUserSelectOneFieldByQuery = _caseUserSelectOneFieldByQuery;


// Case Documents Search Reducer
export const {
  slice: CaseDocumentsSearchSlice,
  dbThunks: _CaseDocumentsSearchThunks,
  selectByQuery: _caseDocumentsSearchSelectByQuery,
  selectors: _caseDocumentsSearchSelectors,
} = createDBServiceSlice<CaseDocumentsSearch>({
  service: "case-documents-search",
  initialState: {
    ...initialState,
    itemsLoaded: true
  },
  getReducerState: (state) => state.DBCaseDocumentsSearchReducer,
});

export const DBCaseDocumentsSearchReducer = CaseDocumentsSearchSlice.reducer;
export const CaseDocumentsSearchReducerActions = CaseDocumentsSearchSlice.actions;
export const DBCaseDocumentsSearchThunks = _CaseDocumentsSearchThunks;
export const caseDocumentsSearchSelectors = _caseDocumentsSearchSelectors;
export const caseDocumentsSearchSelectByQuery = _caseDocumentsSearchSelectByQuery;


/* 
 * =================================================================
 * !!                    DO NOT PUT ANYTHING                        !!
 * !!                       BELOW HERE                             !!
 * =================================================================
 *                              
 *      |\      _,,,---,,_
 * ZZZzz /,`.-'`'    -.  ;-;;,_   Warning! Dragons below!
 *      |,4-  ) )-,_. ,\ (  `'-'
 *     '---''(_/--'  `-'\_)
 *
 * =================================================================
 */

// Must be declared after all the reducers!
export type DBSlice = ReturnType<typeof createDBServiceSlice>;
export const DBReducerMap: Map<string, DBSlice> = new Map(_DBReducerMap);